import React from "react";

export default function ModeAngleSvg(props) {
  return (
    <>
      <div className={props.cname}>
        <svg width="30" height="30">
          <polyline
            points="0, 25 0, 0 25, 0"
            stroke="#1677ff"
            strokeWidth="5"
            fill="none"
            strokeLinecap="round"
          ></polyline>
        </svg>
      </div>
    </>
  );
}
